import { render, staticRenderFns } from "./GebrauchtwagenItem.vue?vue&type=template&id=4c7f1a3d&scoped=true&slot=header&"
import script from "./GebrauchtwagenItem.vue?vue&type=script&lang=js&"
export * from "./GebrauchtwagenItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7f1a3d",
  null
  
)

export default component.exports